import api from '../api';

const projectService = {
    // === Project Management ===

    // Get all projects for teams user belongs to
    getProjects: (params = {}) => api.get('/v1/projects', { params }),

    // Get a single project
    getProject: (id) => api.get(`/v1/projects/${id}`),

    // Create a new project
    createProject: (data) => api.post('/v1/projects', data),

    // Update a project
    updateProject: (id, data) => api.put(`/v1/projects/${id}`, data),

    // Delete a project
    deleteProject: (id) => api.delete(`/v1/projects/${id}`),

    // === Task Management ===

    // Get tasks for a project
    getTasks: (projectId, params = {}) => api.get(`/v1/projects/${projectId}/tasks`, { params }),

    // Get a single task
    getTask: (taskId) => api.get(`/v1/tasks/${taskId}`),

    // Create a new task
    createTask: (projectId, data) => api.post(`/v1/projects/${projectId}/tasks`, data),

    // Update a task (full update - owner only)
    updateTask: (taskId, data) => api.put(`/v1/tasks/${taskId}`, data),

    // Update task status only (team members)
    updateTaskStatus: (taskId, status) => api.patch(`/v1/tasks/${taskId}/status`, { status }),

    // Update task priority only (team members)
    updateTaskPriority: (taskId, priority) => api.patch(`/v1/tasks/${taskId}/priority`, { priority }),

    // Delete a task
    deleteTask: (taskId) => api.delete(`/v1/tasks/${taskId}`),

    // === Task Subtasks ===

    // Get subtasks for a task
    getSubtasks: (parentTaskId, params = {}) => api.get(`/v1/tasks/${parentTaskId}/subtasks`, { params }),

    // Create a subtask
    createSubtask: (parentTaskId, data) => api.post(`/v1/tasks/${parentTaskId}/subtasks`, data),

    // === Task Comments ===

    // Get comments for a task
    getComments: (taskId, params = {}) => api.get(`/v1/tasks/${taskId}/comments`, { params }),

    // Add a comment
    addComment: (taskId, message) => api.post(`/v1/tasks/${taskId}/comments`, { message }),

    // Delete a comment
    deleteComment: (taskId, commentId) => api.delete(`/v1/tasks/${taskId}/comments/${commentId}`),

    // === Task Attachments ===

    // Get attachments for a task
    getAttachments: (taskId) => api.get(`/v1/tasks/${taskId}/attachments`),

    // Add an attachment
    addAttachment: (taskId, uploadId) => api.post(`/v1/tasks/${taskId}/attachments`, { upload_id: uploadId }),

    // Delete an attachment
    deleteAttachment: (taskId, attachmentId) => api.delete(`/v1/tasks/${taskId}/attachments/${attachmentId}`),

    // Upload file to temporary storage
    uploadFile: (formData, onUploadProgress) => api.post('/temp-upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    }),

    // Delete a temporary upload and its physical file from disk
    deleteTempUpload: (uploadId) => api.delete(`/temp-upload/${uploadId}`),

    // Attach uploaded file to task
    attachFileToTask: (taskId, uploadId) => api.post(`/v1/tasks/${taskId}/attachments`, { upload_id: uploadId }),

    // === Task Attachment Viewers ===
    getAttachmentViewUrl: (taskId, attachmentId) =>
        api.get(`/v1/tasks/${taskId}/attachments/${attachmentId}/view`),

    getAttachmentOnlyOfficeConfig: (taskId, attachmentId) =>
        api.get(`/v1/tasks/${taskId}/attachments/${attachmentId}/onlyoffice-config`),

    // === Dashboard ===
    getDashboardStats: () => api.get('/v1/projects/dashboard-stats'),
};

export default projectService;
